import { Link, NavLink } from "react-router-dom";
import { useState } from "react";
import { Menu, X } from "lucide-react";
import { CANDIDATE } from "@/data/content";

const NAV_LINKS = [
  { to: "/", label: "Home", testid: "nav-home" },
  { to: "/about", label: "About", testid: "nav-about" },
  { to: "/issues", label: "Issues", testid: "nav-issues" },
  { to: "/slate", label: "The Slate", testid: "nav-slate" },
  { to: "/vote", label: "Where to Vote", testid: "nav-vote" },
  { to: "/news", label: "News", testid: "nav-news" },
  { to: "/volunteer", label: "Volunteer", testid: "nav-volunteer" },
  { to: "/contact", label: "Contact", testid: "nav-contact" },
];

export const Header = () => {
  const [open, setOpen] = useState(false);

  return (
    <header
      className="sticky top-0 z-40 border-b border-white/10 bg-canvas/70 backdrop-blur-2xl supports-[backdrop-filter]:bg-canvas/60"
      data-testid="site-header"
    >
      <div className="container-x flex h-20 items-center justify-between">
        <Link to="/" className="flex items-center gap-3 leading-tight" data-testid="nav-logo">
          <img
            src={CANDIDATE.logoBadge}
            alt="ROB4MANCH campaign badge"
            className="h-12 w-12 object-contain"
          />
          <div className="flex flex-col">
            <span className="font-display text-2xl font-black tracking-tight text-forest leading-none uppercase">
              ROB<span className="text-terracotta">4</span>NH
            </span>
            <span className="overline mt-1 text-[10px]">
              {CANDIDATE.office} · {CANDIDATE.wards}
            </span>
          </div>
        </Link>

        <nav className="hidden lg:flex items-center gap-8">
          {NAV_LINKS.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={l.testid}
              className={({ isActive }) =>
                `text-sm tracking-wide transition-colors hover:text-forest ${
                  isActive ? "text-forest font-medium" : "text-ink/80"
                }`
              }
              end={l.to === "/"}
            >
              {l.label}
            </NavLink>
          ))}
          <Link to="/donate" className="btn-primary !py-2 !px-5 text-sm" data-testid="nav-donate-btn">
            Donate
          </Link>
        </nav>

        <button
          type="button"
          className="lg:hidden p-2 text-ink"
          onClick={() => setOpen((v) => !v)}
          aria-label="Toggle menu"
          data-testid="nav-mobile-toggle"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden border-t border-white/10 bg-canvas/95 backdrop-blur-2xl" data-testid="nav-mobile-panel">
          <div className="container-x flex flex-col py-6 gap-4">
            {NAV_LINKS.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                onClick={() => setOpen(false)}
                data-testid={`${l.testid}-mobile`}
                className={({ isActive }) =>
                  `text-base ${isActive ? "text-forest font-medium" : "text-ink/80"}`
                }
                end={l.to === "/"}
              >
                {l.label}
              </NavLink>
            ))}
            <Link
              to="/donate"
              onClick={() => setOpen(false)}
              className="btn-primary w-full justify-center !py-3"
              data-testid="nav-donate-btn-mobile"
            >
              Donate
            </Link>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
